import { Component, ChangeDetectionStrategy } from '@angular/core';

import { SnIncident } from '@lib/api/entities';
import { snListStagger, snFadeIn, snFadeOut } from '@lib/common/animations';
import { SnTableBaseComponent } from '@lib/core';

@Component({
  selector: 'sn-incident-table',
  templateUrl: './incident-table.component.html',
  styleUrls: ['./incident-table.component.scss'],
  animations: [snListStagger, snFadeIn, snFadeOut],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IncidentTableComponent extends SnTableBaseComponent<SnIncident> {
  constructor() {
    super();
  }

  public trackBy(index: number, item: SnIncident): any {
    return item.id;
  }
}
